<script>
const interval = [
  {
    duration: '5s',
    text: '5 seconds',
    ms: 5 * 1000
  }, {
    duration: '10s',
    text: '10 seconds',
    ms: 10 * 1000
  }, {
    duration: '30s',
    text: '30 seconds',
    ms: 30 * 1000
  }, {
    duration: '1m',
    text: '1 minute',
    ms: 1000 * 60
  }, {
    duration: '5m',
    text: '5 minutes',
    ms: 1000 * 60 * 5
  }, {
    duration: '10m',
    text: '10 minutes',
    ms: 1000 * 60 * 10
  }, {
    duration: '30m',
    text: '30 minutes',
    ms: 1000 * 60 * 30
  }
]
export default {
  props: {
    default: {
      type: String,
      default: '30s'
    }
  },
  computed: {
    ms() {
      return this.selected === null
        ? interval.find(o => o.duration === this.default).ms
        : interval.find(o => o.duration === this.selected).ms
    },
  },
  data: () => ({
    interval,
    selected: null,
    timer: null
  }),
  methods: {
    toggle() {
      if (this.timer === null) {
        this.startTimer()
      } else {
        this.stopTimer()
      }
    },
    startTimer() {
      if (this.selected === null)
        this.selected = this.default
      this.timer = setInterval(() => this.$emit('clocked'), this.ms)
    },
    stopTimer() {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>
<template>
  <a-button-group>
    <a-dropdown>
      <a-menu slot="overlay">
        <a-menu-item v-for="v in interval" :key="v.duration" @click="(e) => selected = e.key">{{ v.text }}</a-menu-item>
      </a-menu>
      <a-button><a-icon v-if="selected !== null" type="clock-circle" /> {{ selected === null ? 'Interval' : interval.find(o => o.duration === selected).text }} <a-icon type="down" /></a-button>
    </a-dropdown>

    <a-button :type="timer === null ? 'primary' : 'default'" :icon="timer === null ? 'caret-right' : 'pause'" @click="toggle"></a-button>
  </a-button-group>
</template>
